<template>
	<v-dialog
			v-bind="$attrs"
			ref="bwModal"
			:content-class="isDrawer ? 'dialog-drawer' : 'rounded-xl'"
			:fullsreen="isDrawer || null"
			:origin="isDrawer ? 'right' : 'center center'"
			persistent
			scrollable
			:transition="isDrawer ? 'slide-x-reverse-transition' : null"
			:value="true"
			:width="width"
	>
		<v-card class="position-relative" :rounded="!isDrawer ? 'xl' : false">
			<v-card-title
					v-if="title"
					class="d-flex justify-space-between ma-0 ma-md-4"
			>
				<div class="w-100">
					<div class="align-center d-flex justify-space-between">
						<h6>{{ title }}</h6>
					</div>
				</div>
			</v-card-title>
			<v-card-text
					:class="{
						'pa-md-0': drawerOnDesktop
					}"
			>
				<slot name="body" v-html="message"></slot>
			</v-card-text>
			<v-card-actions>
				<slot name="footer"></slot>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'BwModal',
	props: {
		drawerOnDesktop: Boolean,
		message: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: 600
		}
	},
	computed: {
		isDrawer() {
			return this.drawerOnDesktop && this.$vuetify.breakpoint.mdAndUp;
		},

		isMdAndUp() {
			return this.$vuetify.breakpoint.mdAndUp;
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .dialog-drawer {
	margin: 0 !important;
	max-height: 100% !important;
	position: absolute !important;
	right: 0 !important;
}

::v-deep .v-dialog,
::v-deep .v-dialog > .v-card.v-sheet {
	border-radius: 0 !important;
}
</style>
